<template>
	<div class="detailsPaymentsTable">
		<v-data-table
				class="detailsPayments"
				:headers="headers"
				:page.sync="page"
				:items="items"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:items-per-page="getItemsPerPage"
				@page-count="pageCount = $event"
				hide-default-footer
				hide-default-header
				hide-default-body
				fixed-header
		>
			<template v-slot:header="{ props: { headers } }">
				<thead>
				<tr>
					<th
							v-for="(item, index) in headers"
							:class="[{'filter-active': filterClasses[item.valueFilter]},
                                {'dense': item.dense}]"
							:key="index"
							class=""
							:id="'container-'+item.value"
					>
						<div class="filterIcons">
							<sort-btn
									v-if="item.sortable"
									:sortDesc="sortDesc"
									:sortBy="sortBy"
									:data-sort="item.value"
									@updateToggleOrder="toggleOrder"
							></sort-btn>
							<span
									class="headText wh_w"
									:class="{'headText_sorted': getSortColor(sortBy, item.value), 'center': item.value === 'optional'}">
                  {{ item.text }}
              </span>
							<filter-drop-down v-if="item.func" :item="item">
								<filter-table
										:data-filter="filter[item.value]"
										:type-filter="item.model"
										:item="item"
										:model-filter="item.value"
										:filter-update="filterUpdate"
										:is-disabled="filterPreloader"
										:isRefresh="isRefresh"
										:labelFilter="item.text"
										:uniqId="uniqId"
										@change-sort="changeSort"
										@create-refresh="createRefresh"
										@filter-created="filterCreated"
										@updateFilterListAll="onFilteredAll(item)"
								></filter-table>
							</filter-drop-down>
						</div>
					</th>
				</tr>
				</thead>
			</template>
			<template v-slot:body="{ items }">
				<tbody>
				<template v-for="(item, idx) in items">
					<table-tr
							:item="item"
							:key="item.id"
							:idx="idx"
							:checkClasses="checkClasses"
							:permissions="permissions"
							@updateEdit="onEdit"
							@updateCommentsPopup="onCommentsPopup"
					>
					</table-tr>
				</template>
				<tr class="tableBottom">
					<td>n: <span>{{ getUniqUnit }}</span></td>
					<td :key="i" v-for="i in 7"></td>
				</tr>
				</tbody>
			</template>
		</v-data-table>
		<pagination
				v-if="items.length"
				:length="items.length"
				:pageCount="pageCount"
				:itemsPerPage="itemsPerPage"
				:page="page"
				:isRefresh="isRefresh"
				:isRefreshPage="isRefreshPage"
				:pages="pages"
				@updatePagination="onPagination"
				@updateCountPagination="onCountPagination"
		></pagination>
	</div>
</template>

<script>
// components
import TableTr from "@/components/Accounting/Calendar/DetailsPayments/DetailsPaymentsTable/TableTr/TableTr.vue";
// shared
import FilterDropDown from "@/shared/FilterDropDown/FilterDropDown";
import FilterTable from "@/shared/FilterTable/FilterTable";
import Pagination from "@/shared/Pagination/Pagination";
import SortBtn from "@/shared/SortBtn/SortBtn";
// constants
import { detailsPaymentsHeader } from "@/constants/defaultHeader";
// helpers
import { formatCurrency } from "@/helper";
import getUniqId from "@/helper/getUniqId";
import debounce from 'lodash.debounce';
// constants
import { OPTIONAL_KEYS } from "@/constants/constants";

export default {
	name: "DetailsPaymentsTable",
	components: {
		FilterDropDown,
		TableTr,
		FilterTable,
		Pagination,
		SortBtn
	},
	props: {
		listItems: Array,
		filter: Object,
		permissions: Object,
		isRefresh: String,
		getTruckId: Number
	},
	computed: {
		headers() {
			return detailsPaymentsHeader;
		},
		getUniqUnit() {
			return Array.from(new Set(this.listItems.map(item => item.unit))).length;
		},
		getItemsPerPage() {
			return this.itemsPerPage === 'All' ? 99999999 : this.itemsPerPage;
		},
		getTotal() {
			const total = this.listItems.reduce((acc, item) => acc += +item.total, 0);
			return formatCurrency(total);
		},
		items: {
			get() {
				return this.list;
			},
			set(arr) {
				this.list = arr;
			},
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
	},
	watch: {
		listItems(val) {
			this.items = val;
		},
		async isRefresh(val, oldVal) {
			if (val !== oldVal) {
				await this.refreshFilters();
			}
		}
	},
	data() {
		return {
			pages: [ 10, 20, 50, 100, 200, 500 ],
			itemsPerPage: 10,
			page: 1,
			pageCount: 0,
			filterUpdate: false,
			sortBy: "id",
			sortDesc: true,
			menu: false,
			filtersMarker: {},
			filters: {},
			filtersList: {},
			list: this.listItems,
			checkClasses: {},
			filterPreloader: false,
			isRefreshPage: '',
			uniqId: { key: '', id: '' },
			isVisibleItems: false
		};
	},
	methods: {
		onEdit(groupIds) {
			this.$emit('updateEditDetails', groupIds);
		},
		onFilteredAll(item) {
			this.filterCreated(item.value);
			this.uniqId = {
				id: getUniqId(),
				key: item.value
			};
		},
		onPagination(value) {
			this.page = value;
		},
		onCountPagination(value) {
			this.itemsPerPage = value;
		},
		async refreshFilters() {
			this.search = "";
			this.sortDesc = false;
			this.sortBy = "id";
			this.items = this.listItems;
			this.page = 1;

			if (Object.values(this.filterClasses)) {
				for (const i in this.filters) {
					const isOptional = OPTIONAL_KEYS.some(item => i.includes(item));
					this.filters[i] = isOptional ? -1 : [];
				}

				this.filters['filter_reviewed'] = 0;
				this.filterUpdate = true;
			}

			/*const obj = { date: formatDate(this.currentDate, 1), filters: {} };
			await this.onNewWorkOrderList(obj);*/
		},
		onCommentsPopup(values) {
			this.$emit('updateCommentsPopup', values);
		},
		createRefresh(model) {
			this.filtersMarker[model] = true;
			if (!Object.values(this.filtersMarker).includes(false)) {
				this.filterUpdate = false;
				for (const i in this.filtersMarker) {
					this.filtersMarker[i] = true;
				}
			}
			this.filterClasses = this.filters;
		},
		filterCreated(model) {
			this.filtersMarker[model] = false;
		},
		getSortColor(sortBy, value) {
			return sortBy === value || (sortBy && value.includes(sortBy));
		},
		toggleOrder(val) {
			const { valueFilter } = detailsPaymentsHeader.find(item => item.value === val);
			this.sortBy = valueFilter;
			this.sortDesc = !this.sortDesc;
		},
		initDetailPaymentsFilter: debounce(function(values) {
			this.$emit('updateDetailsPaymentsFilters', values);
			this.isRefreshPage = getUniqId();
			this.filterPreloader = false;
		}, 800),
		changeSort({ key, value, model }) {
			switch (model) {
				case 'date':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key]['from'];
					break;
				case 'number':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key]['type'];
					break;
				case 'note':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				case 'options':
					this.filters[key] = Number(value);
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				case 'checkbox':
					this.filters[key] = Number(value);
					break;
				case 'list':
					this.filters[key] = value.map(item => item);
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				default:
					this.filters[key] = value.map(item => item);
					this.filterClasses[key] = !!this.filters[key].length;
			}

			this.filterPreloader = true;
			this.initDetailPaymentsFilter(this.filters);
		},
		async getFilterList() {
			for (let i = 0; i < this.headers.length; i++) {
				this.filtersMarker[this.headers[i].value] = true;
				this.$set(this.checkClasses, this.headers[i].value, false);
				const value = this.headers[i].value;

				if (value.includes('filter')) {
					this.filters[value] = [];
				}

				this.filtersList[value] = [];
			}
		}
	},
	created() {
		this.getFilterList();
	}
};
</script>

<style scoped lang="scss">
@import "DetailsPaymentsTable";
</style>

<style>
.detailsPayments .v-data-table__wrapper {
	max-height: 478px;
}
</style>
